import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import { MouseEvent, useState } from 'react';
import { Button, Confirm, useNotify, useRecordContext, useRefresh, useUpdate } from 'react-admin';

type ProductRecord = {
  archivedAt?: string | null;
  id: string;
  name?: string;
};

export const ProductArchiveButton = () => {
  const record = useRecordContext<ProductRecord>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  const isArchived = Boolean(record?.archivedAt);
  const action = isArchived ? 'Restore' : 'Archive';

  const [update, { isLoading }] = useUpdate(
    'products',
    {
      id: record?.id,
      data: { archivedAt: isArchived ? null : new Date().toISOString() },
      previousData: record,
    },
    {
      onSuccess: () => {
        notify(`Product ${action.toLowerCase()}d successfully`, { type: 'success' });
        refresh();
      },
      onError: error => {
        notify(`Error: ${error}`, { type: 'warning' });
      },
    },
  );

  if (!record) {
    return null;
  }

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <Button label={action} onClick={handleClick} disabled={isLoading} color={isArchived ? 'info' : 'error'}>
        {isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
      </Button>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title={`Confirm Product ${action}`}
        content={`Are you sure you want to ${action.toLowerCase()} ${record.name ?? 'this product'}?`}
        onConfirm={() => {
          update();
          setOpen(false);
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
